import React, { useRef, useState } from "react";
import cs from "classnames";
import { useOutsideClick } from "@hooks/useOutsideClick";
import { HEXDropDownArrowIcon } from "@icons/hexpert/HEXDropDownArrowIcon";
import { HEXCheckIcon } from "@icons/hexpert/HEXCheckIcon";
import { PageQuestionOption } from "../../types/hexpertTypes";
import './DropDown.scss';

type DropDownProps = {
  name?: string;
  selected?: string;
  defaultValue?: string;
  onChange?: (option: string) => void;
  options?: PageQuestionOption[];
};

export const DropDown = ({
  name,
  selected,
  defaultValue,
  onChange,
  options,
}: DropDownProps) => {
  const dropDownRef = useRef<HTMLDivElement>(null);

  const [open, setOpen] = useState<boolean>(false);

  useOutsideClick(dropDownRef, () => setOpen(false));

  return (
    <>
      <select
        className={cs("c-hex-dropdown--selected-container-mobile", {
          "c-hex-dropdown-selected-container-active-mobile": Boolean(selected),
        })}
        onChange={(e) => {
          onChange(e.target.value);
        }}
        name={name}
        value={selected ?? ""}
      >
        {options?.map((option) => (
          <option key={option.Value} value={option.Value}>
            {option.Caption}
          </option>
        ))}
      </select>
      <div
        className={cs("c-hex-dropdown", {
          "c-hex-dropdown-open": open,
        })}
        ref={dropDownRef}
      >
        <div
          className={cs("c-hex-dropdown-selected-container", {
            "c-hex-dropdown-selected-container-active": Boolean(selected),
          })}
          onClick={() => setOpen(!open)}
        >
          <label htmlFor={name} className="c-hex-dropdown-selected-label">
            {Boolean(selected) ? (
              <>
                <HEXCheckIcon /> {selected}
              </>
            ) : (
              defaultValue
            )}
          </label>
          <HEXDropDownArrowIcon />
        </div>
        <ul className={"c-hex-dropdown-list-container"}>
          {options
            ?.filter((o) => o.Value !== selected)
            .map((option) => (
              <li
                key={option.Value}
                value={option.Value}
                className={"c-hex-dropdown-list-item"}
                onClick={() => {
                  setOpen(false);
                  onChange(option.Value);
                }}
              >
                {option.Caption}
              </li>
            ))}
        </ul>
      </div>
    </>
  );
};
